import React from 'react';
import ChatIcon from '@mui/icons-material/Chat';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import PreChatForm from '@platform/core/src/components/chat/PreChatForm';

const workoutSessionPreChatConfig = [
  {
    inputType: 'text',
    key: 'workoutName',
    label: 'Workout Name (Optional)',
    optional: true,
    context: {
      type: 'metadata',
      notes: (value) => JSON.stringify({ initial_name: value }),
    }
  },
  {
    resourceType: 'workout_plan',
    label: 'Workout Plan (Optional)',
    max: 1,
    optional: true,
  },
  {
    resourceType: 'location',
    label: 'Location (Optional)',
    max: 1,
    optional: true,
    priorityReferenceSource: 'workout_plan',
  },
];

export const onboardingPreChatConfig = [];

export const preChatFormComponent = PreChatForm;

export const startSessionButtons = [
  {
    id: 'default-chat',
    label: 'General Chat',
    icon: <ChatIcon />,
    teamName: null,
    variant: 'contained',
    infoContent: 'Start a general conversation with your AI assistant. Ask questions, talk to the assistant, locate videos, or just chat about your fitness journey.',
  },
  {
    id: 'design-workout',
    label: 'Design Workout',
    icon: <FormatListNumberedIcon />,
    // teamName: 'interactive_workout_plan_team', // REMOVED: No longer starting a chat session
    createResourceType: 'workout_plan', // ADDED: Opens the creation modal for this resource type
    variant: 'contained',
    infoContent: 'Work with the AI assistant to create a new, structured workout plan from scratch tailored for you. The assistant will guide you through the process.',
  },
  {
    id: 'workout-session',
    label: 'Workout Session (Logging)',
    icon: <SportsGymnasticsIcon />,
    teamName: 'active_workout_team',
    preChatConfig: workoutSessionPreChatConfig,
    variant: 'contained',
    clearWorkspace: false,
    infoContent: 'Start logging a workout session. You can either be guided by a pre-made plan or simply log activities as you go (freestyle).',
  }
];